import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/style/init.less'
import VueScrollTo from 'vue-scrollto'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

createApp(App)
  .use(store)
  .use(router)
  .use(ElementPlus)
  .use(VueScrollTo, {
    container: 'body',   // 滚动元素
    duration: 1000,  // 动画时长
    easing: 'ease',  // 动画曲线
    offset: 0,  // 滚动终点距离父元素顶部距离
    force: true,  // 强制立即执行，即便元素是可见的
    cancelable: false,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false, // x 轴禁止滚动
    y: true
  })
  .mount('#app')
